<template>
 <div>
   <el-tree :data="tree_list" :props="defaultProps"></el-tree>
   <el-button type="primary" @click="searchHandle">查询</el-button>
 </div>
</template>

<script>
import data from "../../view/test/json_test"
export default {
  name: "list_test",
  data(){
    return{
      tree_list:data.data,
      defaultProps: {
        children: 'childen_data',
        label: 'name',
      },
      task_hash:{},
    }
  },
  created() {
    this.tree_list.forEach(a=>{
      a.childen_data.forEach(b=>{
        b.childen_data.forEach(v=>{
          this.task_hash[v.task_id] = v;
        })
      })
    })
  },
  methods:{
    //查询一个name testRapidi2111 的任务
    searchHandle(){
     let seatch_task = {
       task_id:'wb57418c123',
       worker_id: "wxune*za7ytB*gt4DI1kfs~a",
       id:'1'
     }
      this.searchHandleOne(seatch_task)//普通查询方式
      this.searchHandleTwo(seatch_task)//优化查询方式
    },
    searchHandleOne(seatch_task){
      this.tree_list.forEach(a=>{
        if (a.id == seatch_task.id){
          a.childen_data.forEach(b=>{
            if (b.worker_id == seatch_task.worker_id){
              b.childen_data.forEach(c=>{
                if (c.task_id == seatch_task.task_id){
                  // console.log('找到啦')
                }
              })
            }
          })
        }
      })
      // console.timeEnd('timer1')
    },
    searchHandleTwo(seatch_task){
      // console.time('timer2')
      let task =this.task_hash[seatch_task.task_id]
      // console.timeEnd('timer2')
      // console.log(task.task_id,'找到啦')
    }
  }
}
</script>

<style scoped>

</style>
